export default {
  XXS: 374,
  XS: 767,
  SM: 768,
  MD: 1024,
  LG: 1440,
  XL: 1800
};